<main class="pb-0">
  <section
    class="py-5"
    style="
      background-image: url('assets/images/login-background.jpg');
      background-size: cover;
    "
  >
    <div class="container px-4 py-5">
      <div class="row align-items-stretch g-0">
        <div class="col-md-10 mx-auto col-lg-8 shadow">
          <div class="p-4 p-md-5 shadow bg-light h-100">
            <h1 class="display-6">Forgot Password</h1>
            <div *ngIf="!submitted">
              <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <div class="col-md-12">
                  <label for="userIdentifier"
                    >Enter your e-mail or username:</label
                  >
                </div>
                <div class="col-md-6">
                  <input
                    type="text"
                    formControlName="userIdentifier"
                    class="form-control"
                    id="userIdentifier"
                    [ngClass]="{ 'is-invalid': form.controls['userIdentifier'].invalid && form.controls['userIdentifier'].touched }"
                  />
                  <div
                    *ngIf="
                      form.controls['userIdentifier'].invalid &&
                      form.controls['userIdentifier'].touched
                    "
                    class="invalid-feedback"
                  >
                    The e-mail / username field is required.
                  </div>
                </div>
                <br />
                <div class="col-md-3">
                  <button type="submit" class="btn btn-primary">Submit</button>
                </div>
              </form>
            </div>
            <div *ngIf="submitted" class="text-success mt-3">
              <p>
                If an account exists with that information, a password reset link
                has been sent.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
